<template>
	<div>
		<div class="mt-5 block-content bg-warning-light">
			<div class="text-center h5 fw-bold">
				Your Lifetime Membership is still pending. Please follow the payment instructions below to complete your transaction
			</div>
			<div class="text-center h4 fw-semibold mb-3">
				{{data.codetype}} LIFETIME MEMBERSHIP
				<div class="mt-3">Amount to pay: &#8369; {{data.amount}}</div>
			</div>
			<!-- <div v-if="data.mop=='BANK_TRANSFER'" class="block-content block-content-full">
							
				<p class="fw-bold">Do a fund transfer to the bank details below:</p>
				<table>
					<tbody>
						<tr>
							<td>Bank Name</td>
							<th class="ps-2">BDO Savings Account</th>
						</tr>
	                    <tr>
	                        <td>Account Number</td>
	                        <th class="ps-2">00412-016-5097</th>
	                    </tr>
	                    <tr>
	                        <td>Account Name</td>
	                        <th class="ps-2">Bo Sanchez Inc.</th>
	                    </tr>
	                    <tr>
	                        <td>Amount</td>
	                        <th class="ps-2">&#8369; {{data.amount}}</th>
	                    </tr>
					</tbody>
				</table>

				<div class="mt-4">
					<ul>
						<li class="mb-15">
							<h6>Instructions</h6>
							<div class="mt-30 mb-30">
								<ol>
									<li>Please email your proof of payment to <span class="text-info">support@trulyrichclub.com</span></li>
									<li>We will get back to you within 2-3 banking days.</li>
								</ol>
							</div>
						</li>
					</ul>
				</div>

			</div> -->
		</div>

		<div class="block">
			<div class="block-content">
				<div class="row">
					<p class="fw-bold">Payment Options</p>
					<div class="col-6">
						<div class="form-check form-block mb-4">
							<input
								v-model="formLifetime.payment_method"
								class="form-check-input"
								type="radio"
								:value="'CARD'"
								id="card"
								name="payment_method"
							/>
							<label class="form-check-label" for="card">
								<span
									class="d-flex align-items-center"
									style="
										background-image: url(/media/logo/stripe-logo.png);
										background-size: contain;
										background-repeat: no-repeat;
										background-position: center;
										height: 100px;
									"
								>
								</span>
							</label>
						</div>
					</div>
					<div class="col-6">
						<div class="form-check form-block mb-4">
							<input
								v-model="formLifetime.payment_method"
								class="form-check-input"
								type="radio"
								:value="'BANK_TRANSFER'"
								id="bank_transfer"
								name="payment_method"
							/>
							<label class="form-check-label" for="bank_transfer">
								<span
									class="d-flex align-items-center"
									style="
										background-image: url(/media/logo/bank_transfer.png);
										background-size: contain;
										background-repeat: no-repeat;
										background-position: center;
										height: 100px;
									"
								>
								</span>
							</label>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div v-if="formLifetime.payment_method == 'CARD'">
							<div v-if="member.has_card">
								<div class="form-check form-switch mb-4">
									<input
										v-model="formLifetime.use_existing_card"
										class="form-check-input"
										type="checkbox"
										:value="true"
										id="example-switch-default1"
										name="example-switch-default1"
									/>
									<label class="form-check-label form-label" for="example-switch-default1">
										Use existing card
									</label>
								</div>
								<div v-if="formLifetime.use_existing_card" class="mb-4">
									<p class="mb-0">
										<span class="fw-semibold">CARD: </span>
										<i>**** **** **** {{ member.card.last4 }}</i>
										<span class="badge bg-primary ms-2">{{ member.card.brand }}</span>
									</p>
								</div>
							</div>
							<div v-if="!formLifetime.use_existing_card" class="form-group mb-4">
								<span class="text-danger fw-bold mx-1">*</span><label class="form-label">Card Information</label>
								<stripe @accept-token="acceptToken" ref="stripe" />
								<div v-if="formLifetime.errors.card" class="invalid-feedback d-block">
									<i class="fa fa-exclamation-circle"></i>
									{{ formLifetime.errors.card }}
								</div>
							</div>
						</div>

						<div v-if="formLifetime.payment_method == 'BANK_TRANSFER'" class="block block-rounded">
							<div class="block-content block-content-full">
								
	                			<p class="fw-bold">Do a fund transfer to the bank details below:</p>
	                			<table>
	                				<tbody>
	                					<tr>
	                						<td>Bank Name</td>
	                						<th class="ps-2">BDO Savings Account</th>
	                					</tr>
	                                    <tr>
	                                        <td>Account Number</td>
	                                        <th class="ps-2">00412-016-5097</th>
	                                    </tr>
	                                    <tr>
	                                        <td>Account Name</td>
	                                        <th class="ps-2">Bo Sanchez Inc.</th>
	                                    </tr>
	                				</tbody>
	                			</table>

	                			<div class="mt-4">
	                				<ul>
	                					<li class="mb-15">
	                						<h6>Instructions</h6>
	                						<div class="mt-30 mb-30">
	                							<ol>
	                								<li>Please email your proof of payment to <span class="text-info">support@trulyrichclub.com</span></li>
	                								<li>We will get back to you within 2-3 banking days.</li>
	                							</ol>
	                						</div>
	                					</li>
	                				</ul>
	                			</div>

							</div>
						</div>
					</div>
				</div>
				<div v-if="(formLifetime.prev_mop=='CARD' && formLifetime.payment_method=='BANK_TRANSFER') || (formLifetime.prev_mop=='BANK_TRANSFER' && formLifetime.payment_method=='CARD')" class="row my-5">
					<div class="col-12 text-center">
						<button type="button" @click="payNow()" :disabled="formLifetime.processing" class="btn btn-success">
							<span v-if="formLifetime.processing" class="me-1">
								<div class="spinner-border spinner-border-sm text-white" role="status" >
									<span class="sr-only me-1">Please wait...</span>
								</div>
							</span>
							<span v-if="formLifetime.prev_mop=='CARD' && formLifetime.payment_method=='BANK_TRANSFER'">Proceed</span>
							<span v-if="formLifetime.prev_mop=='BANK_TRANSFER' && formLifetime.payment_method=='CARD'">Pay Now</span>
						</button>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

	import Stripe from '../Shared/Components/Stripe';
	import { onMounted, ref, watch } from 'vue';
	import { useForm, usePage } from '@inertiajs/inertia-vue3';
	import { createToaster } from '@meforma/vue-toaster';
	export default{
		props:{
			data 		: String,
			member 	: Object,
		},
		components: { Stripe },
		setup(props){

			const formLifetime = useForm({
				counter 			: props.data.counter,
				prev_mop 			: props.data.mop,
				payment_method 		: props.data.mop,
				txnid 				: props.data.txnid,
				subscription 		: props.data.optiontype,
				token 				: null,
				use_existing_card 	: props.member.has_card?true:false,
				amount 				: props.data.orig_amount,
			});

			const acceptToken = (token) => {
							formLifetime.token = token
						};

			const payNow = ()=>{
				formLifetime.post(route('member.post.upgrade-lifetime'), {
							// preserveState: true,
							// preserveScroll: true,
							// only: ['flash','unimember','subscriptions'],
							// onSuccess: () => toggleModal,
						})
			}

			watch(
				() => formLifetime.payment_method,
				(payment_method) => {
					
					if(payment_method=='CARD' && props.member.has_card)
					{
						formLifetime.use_existing_card = true;
					}else{
						formLifetime.use_existing_card = false;
					}

					if(payment_method!='CARD')
					{
						formLifetime.token = null;
					}
				}
			)

			watch(
				() => formLifetime.use_existing_card,
				(use_existing_card) => {
					
					if(use_existing_card==true)
					{
						formLifetime.token = null;
					}
				}
			)

			return{
				formLifetime,
				acceptToken,
				payNow,
			}
		}
	}
</script>